export abstract class NbaBaseResolversCollection<T extends { identifier: string }> {
  protected readonly resolvers: Record<string, T> = {};

  public constructor(resolvers: T[]) {
    for (const resolver of resolvers) {
      this.resolvers[resolver.identifier] = resolver;
    }
  }

  public get(resolver: string): T {
    return this.resolvers[resolver];
  }

  public getAll(): T[] {
    return Object.keys(this.resolvers).map((resolver: string): T => this.resolvers[resolver]);
  }

  public count(): number {
    return Object.keys(this.resolvers).length;
  }
}
